import React, { useMemo } from 'react';
import { useApp } from '@/store/AppContext';
import { useTranslation } from '@/i18n/useTranslation';
import { getSsoProfileUrl } from '@/config/hosts';

const buildSubscriptionSsoUrl = () => getSsoProfileUrl(window.location.href);

export default function TrialBanner() {
  const { user, isAuthenticated } = useApp();
  const { t } = useTranslation();

  const daysRemaining = useMemo(() => {
    const trialEndsRaw = user?.trial_ends;
    if (!trialEndsRaw) return null;
    const trialEndsDate = new Date(trialEndsRaw);
    if (Number.isNaN(trialEndsDate.getTime())) return null;
    const diffMs = trialEndsDate.getTime() - Date.now();
    return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
  }, [user?.trial_ends]);

  if (!isAuthenticated || daysRemaining === null) {
    return null;
  }

  const isActiveSubscription = user?.subscription_status === 'active';
  const buttonLabel = daysRemaining > 0 ? t('trial.upgradeNow') : t('trial.openBilling');

  return (
    <div className={`${daysRemaining > 0 ? 'bg-accent text-bg-main' : 'bg-amber-500 text-bg-main'} border-b border-border`}>
      <div className="px-3 md:px-4 py-2 flex items-center justify-center gap-3 text-xs md:text-sm">
        {daysRemaining > 0 ? (
          <span>
            {t('trial.active', {
              days: String(daysRemaining),
              daysLabel: daysRemaining === 1 ? t('trial.day') : t('trial.days'),
            })}
          </span>
        ) : (
          <span>
            {isActiveSubscription
              ? `${t('trial.subscriptionActive')}${user?.subscription_plan ? ` (${user.subscription_plan})` : ''}`
              : t('trial.ended')}
          </span>
        )}

        {!isActiveSubscription && (
          <button
            type="button"
            onClick={() => { window.location.href = buildSubscriptionSsoUrl(); }}
            className="h-7 px-3 rounded-full bg-black text-white border border-black hover:opacity-80 transition-opacity font-semibold"
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
}
